export default __webpack_public_path__ + "static/media/algorithm3.3b246140.jpeg";